import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
    GetProductsResponse,
    GetProductResponse,
    SuccessResponse,
    DeleteResourceResponse,
    AddResourceResponse,
} from "../../interface/products.interface";

class AdminProductsService {
    /**
     * 📦 GET ALL
     */
    async getProducts(): Promise<GetProductsResponse> {
        const response = await apiClient.get<GetProductsResponse>(
            env.ADMIN_PRODUCTS_URL
        );

        return response.data;
    }

    /**
     * 📄 GET ONE
     */
    async getProduct(id: string): Promise<GetProductResponse> {
        const response = await apiClient.get<GetProductResponse>(
            `${env.ADMIN_PRODUCTS_URL}/${id}`
        );

        return response.data;
    }

    /**
     * ➕ CREATE
     */
    async createProduct(payload: FormData): Promise<SuccessResponse> {
        const response = await apiClient.post(
            env.ADMIN_PRODUCTS_URL,
            payload
        );

        return response.data;
    }

    /**
     * ✏️ UPDATE
     */
    async updateProduct(
        id: string,
        payload: any
    ): Promise<SuccessResponse> {
        const response = await apiClient.put(
            `${env.ADMIN_PRODUCTS_URL}/${id}`,
            payload
        );

        return response.data;
    }

    /**
     * 🖼️ UPDATE THUMBNAIL
     */
    async updateThumbnail(
        id: string,
        payload: FormData
    ): Promise<SuccessResponse> {
        const response = await apiClient.post(
            env.ADMIN_PRODUCT_THUMBNAIL_URL(id),
            payload
        );

        return response.data;
    }

    /**
     * 🖼️ UPLOAD GALLERY (replace all max 5)
     */
    async uploadGallery(
        id: string,
        payload: FormData
    ): Promise<SuccessResponse> {
        const response = await apiClient.post(
            env.ADMIN_PRODUCT_GALLERY_URL(id),
            payload
        );

        return response.data;
    }

    /**
     * 🗑️ DELETE IMAGE GALLERY
     */
    async deleteGalleryImage(
        id: string,
        index: number
    ): Promise<SuccessResponse> {
        const response = await apiClient.delete(
            env.ADMIN_PRODUCT_GALLERY_DELETE_URL(id, index)
        );

        return response.data;
    }

    /**
     * ❌ DELETE PRODUCT
     */
    async deleteProduct(id: string): Promise<SuccessResponse> {
        const response = await apiClient.delete(
            `${env.ADMIN_PRODUCTS_URL}/${id}`
        );

        return response.data;
    }
    /**
  * ➕ ADD RESOURCE (file or link)
  */
    async addResource(
        productId: string,
        payload: FormData
    ): Promise<AddResourceResponse> {
        const response = await apiClient.post(
            env.ADMIN_PRODUCT_RESOURCES_URL(productId),
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    }

    /**
     * 🗑️ DELETE RESOURCE
     */
    async deleteResource(
        productId: string,
        resourceId: string
    ): Promise<DeleteResourceResponse> {
        const response = await apiClient.delete(
            env.ADMIN_PRODUCT_RESOURCE_DELETE_URL(productId, resourceId)
        );
        return response.data;
    }

}

export const adminProductsService = new AdminProductsService();